export default __webpack_public_path__ + "static/media/clockIcon.4e5d323d.svg";